// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3fWnQ","label":"Completed_label__QgnVP"};